module.exports = __webpack_public_path__ + "static/media/02.265814a7.png";